import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SystemApp} from '../constans/SystemConfigurations';
import {ApiUrl} from '../shared/models/apiurl.models';

/** SCRUM-124: one accepted terms version. */
export interface TermsAcceptanceInfo {
  termsVersion: string;
  acceptedAt: string;
  acceptedAtDisplay: string;
  acceptedDate: string;
  acceptedTime: string;
  source: string;
  isCurrent: boolean;
  /** SCRUM-124: API path of the archived text of this version. */
  termsUrl?: string;
}

/** SCRUM-124: GET /client-api/consent/terms/<version>/ */
export interface TermsVersionText {
  version: string;
  title: string;
  content: string;
  effective_date: string | null;
  isCurrent: boolean;
}

/** SCRUM-169: GET/POST /client-api/consent/ */
export interface ConsentStatus {
  currentTermsVersion: string;
  acceptTerms: boolean;
  termsAcceptance: TermsAcceptanceInfo | null;
  termsArchive: TermsAcceptanceInfo[];
  acceptAdv: boolean;
  marketingConsentAt: string | null;
  marketingWithdrawnAt: string | null;
}

@Injectable({providedIn: 'root'})
export class ConsentService {

  constructor(private http: HttpClient, private apiKey: ApiUrl) {}

  private get options() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': this.apiKey.getJWTToken(),
        'X-Client-Source': 'web'
      })
    };
  }

  private get url(): string {
    return `${SystemApp.base_url_api}/client-api/consent/`;
  }

  getStatus(): Observable<ConsentStatus> {
    return this.http.get<ConsentStatus>(this.url, this.options);
  }

  /** SCRUM-124: the exact text of a terms version (public). */
  getTermsVersion(version: string): Observable<TermsVersionText> {
    return this.http.get<TermsVersionText>(
      `${SystemApp.base_url_api}/client-api/consent/terms/${encodeURIComponent(version)}/`);
  }

  /** Send only the keys you want to change. */
  update(change: {acceptTerms?: boolean; acceptAdv?: boolean}): Observable<ConsentStatus> {
    return this.http.post<ConsentStatus>(this.url, change, this.options);
  }
}
